import ContentHeader from "../../widgets/contentHeader/ContentHeader";
import AddressInfo from "../../widgets/objectsOnMapPointInfo/AddressInfo";
import FederalRoadsInfo from "../../widgets/objectsOnMapPointInfo/federalRoadsInfo/FederalRoadsInfo";
import ObjectsInfo from "../../widgets/objectsOnMapPointInfo/objectsInfo/ObjectsInfo";
import RegionsInfo from "../../widgets/objectsOnMapPointInfo/regionsInfo/RegionsInfo";

export default function ObjectsOnMapPointInfo() {
    return (
        <>
            <ContentHeader title="Информация по объектам на карте" />
            <div className="objects-on-map-point-info-div">
                <AddressInfo />
                <RegionsInfo />
                <FederalRoadsInfo />
                <ObjectsInfo />
            </div>
        </>
    )
}
